export default "__VITE_ASSET__BIZ0cUfz__"